module.exports = __webpack_public_path__ + "media/images/herospark_transparente-ef42de65b2546508d900182fce03e802.png";